import type { IconType } from 'react-icons'
import { LuBookOpen, LuFlag, LuMedal, LuPartyPopper } from 'react-icons/lu'
import type { LevelIconKey } from './levelHelpers'

/**
 * Icon component for every supported level icon key. Typed as a Record over
 * `LevelIconKey`, so adding a key to `LEVEL_ICON_KEYS` without mapping it here
 * fails the type check.
 */
export const LEVEL_ICON_COMPONENTS: Record<LevelIconKey, IconType> = {
  flag: LuFlag,
  'book-open': LuBookOpen,
  'party-popper': LuPartyPopper,
  medal: LuMedal,
}
